import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import {
  getInitialLoadIcons,
  getOtherIcons,
  ZeeFontBold,
  ZeeFontMedium,
  ZeeFontRegular
} from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
import {
  InitialLoadIconsSet,
  OtherIconsSet
} from 'src/utils/constants/IconsConstants';

export const backgroundWrapper = css`
  position: relative;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  gap: 10px;
  overflow: hidden;
  white-space: nowrap;
  justify-content: space-between;
  ${MQ.MediaMd} {
    position: absolute;
  }
  &:before {
    ${MQ.MediaLg} {
      top: 0;
    }
    background: linear-gradient(
      358.45deg,
      #100718 42.44%,
      rgba(15, 6, 23, 0.31) 120.64%
    );
    background-repeat: no-repeat;
    background-position: center top;
    background-size: cover;
    content: '';
    height: 120%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    will-change: transform;
    z-index: 1;
  }
`;

export const backgroundGrid = css`
  width: 25%;
`;

export const backgroundGridImage = css`
  width: 100%;
  border-radius: 8px;
`;

export const contentSection = css`
  position: relative;
  top: -90px;
  ${MQ.MediaMd} {
    top: 62px;
  }
  padding: 0 24px 10px 24px;
  z-index: 2;
  width: 100%;
`;

export const title = css`
  color: ${colors.white};
  ${ZeeFontBold(18, 24)};
  margin-bottom: 20px;
`;

export const applyCodeBox = css`
  margin: 24px 0;
  align-items: center;
  background: ${colors.SearchCardBg};
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  padding: 10px 14px;
`;

export const couponImgContainer = css`
  padding: 0 5px;
`;

export const couponTextContainer = css`
  flex: 1;
  color: ${colors.white};
  ${ZeeFontRegular(12, 20)};
`;
export const viewAllIcon = css`
  ${getInitialLoadIcons(InitialLoadIconsSet.VIEW_ALL)}
  color: ${colors.white};
`;

export const popupPaymentContainer = css`
  background: ${colors.SearchCardBg};
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 12px 24px;
`;

export const mainSection = css`
  display: flex;
  margin-bottom: 10px;
`;
export const upiSection = css`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
`;
export const buyPremiumSection = css`
  flex: 1;
`;

export const upiText = css`
  align-items: center;
  color: ${colors.NewSubscriptionCouponText};
  display: flex;
  ${ZeeFontBold(14, 20)};
  padding-bottom: 5px;
`;
export const text = css``;
export const icon = css`
  ${getOtherIcons(OtherIconsSet.UP_ARROW)}
  color: ${colors.white};
  ${ZeeFontRegular(30, 20)};
`;

export const premiumBtn = css`
  ${ZeeFontRegular(14, 20)};
  color: ${colors.white};
  padding: 10px;
`;

export const loginMsgContainer = css`
  text-align: center;
  ${ZeeFontRegular(14, 20)};
  color: ${colors.greyText};
`;

export const loginText = css`
  color: ${colors.Lavender};
  margin-left: 5px;
  cursor: pointer;
`;

export const cohortInfo = css`
  display: flex;
  background: linear-gradient(
      91.16deg,
      rgba(45, 73, 46, 0.2) 50.58%,
      rgba(29, 21, 38, 0) 97.44%
    ),
    #1d1425;
  border-radius: 8px;
  margin: 10px 0 25px;
  padding: 7px;
`;

export const cohortInfoTxt = css`
  color: ${colors.white};
  ${ZeeFontRegular(11, 20)}
  margin-left: 5px;
`;
